import React, { useState } from "react";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Courses from "./components/Courses";
import PdfViewer from "./components/PdfViewer";
import PresentationSlides from "./components/PresentationSlides";
import WorksheetViewer from "./components/WorksheetViewer";
import SelfAssessmentQuiz from "./components/SelfAssessmentQuiz";
import Contact from "./components/Contact";
import CallToActionBanner from "./components/CallToActionBanner";
import Footer from "./components/Footer";
import "./App.css";

const App = () => {

const [activePage, setActivePage] = useState("Video Tutorials");
const [activeTab, setActiveTab] = useState("video"); // Default tab
  return (
    <div className="app-container">
     <Header
  setActivePage={setActivePage}
  activePage={activePage}
  setActiveTab={setActiveTab} // ✅ Pass this down
/>
    <Banner setActivePage={setActivePage} setActiveTab={setActiveTab} />

      <section className="course-section">
        <h2>Our Comprehensive Learning Solutions</h2>
        <p>
          Explore our innovative offerings designed to enhance engagement and
          learning efficiency through interactive videos, materials, and slides.
        </p>
      </section>

      {/* Tabbed content area */}
      {(activePage === "all" ||
        activePage === "Learning Materials" ||
        activePage === "Presentation Slides" ||
        activePage === "Worksheets" ||
        activePage === "Self Assessment"||
        activePage === "Video Tutorials") && (
        <section className="tabs-section">
          <div className="tabs-header">
            <button
              className={`tab ${activeTab === "video" ? "active" : ""}`}
             onClick={() => {
      setActiveTab("video");
      setActivePage("Video Tutorials");
    }}
            >
              🎥 Video Tutorials
            </button>
            <button
              className={`tab ${activeTab === "pdf" ? "active" : ""}`}
               onClick={() => {
      setActiveTab("pdf");
      setActivePage("Learning Materials");
    }}
            >
              📘 Learning Materials
            </button>
            <button
              className={`tab ${activeTab === "ppt" ? "active" : ""}`}
              onClick={() => {
      setActiveTab("ppt");
      setActivePage("Presentation Slides");
    }}
            >
              🖥️ Presentation Slides
            </button>
            <button
      className={activeTab === "worksheet" ? "tab active" : "tab"}
       onClick={() => {
      setActiveTab("worksheet");
      setActivePage("Worksheets");
    }}
    >
      📝 Worksheets
            </button>
            <button
              className={activeTab === "quiz" ? "tab active" : "tab"}
              onClick={() => {
      setActiveTab("quiz");
      setActivePage("Self Assessment");
    }}
            >
              🧭 Self Assessment Quiz
            </button>
          </div>

          <div className="tabs-content">
            {activeTab === "video" && (
              <div className="tab-pane" id="video-tutorials-section">
                <Courses />
              </div>
            )}
            {activeTab === "pdf" && (
              <div className="tab-pane">
                <PdfViewer />
              </div>
            )}
            {activeTab === "ppt" && (
              <div className="tab-pane">
                <PresentationSlides />
              </div>
            )}
            {activeTab === "worksheet" && (
      <div className="tab-pane">
        <WorksheetViewer />
      </div>
            )}
            {activeTab === "quiz" && (
              <div className="tab-pane">
                <SelfAssessmentQuiz />
              </div>
            )}
          </div>
        </section>
      )}

      {activePage === "contact" && <Contact />}

      <CallToActionBanner
  setActivePage={setActivePage}
  setActiveTab={setActiveTab}
/>
      <Footer />
    </div>
  );
};

export default App;
